export enum EIndicationStatus {
  'Atendido' = 'Atendido',
  'Aguardando agendamento' = 'Aguardando agendamento',
  'Agendado' = 'Agendado',
  'Aguardando novo agendamento' = 'Aguardando novo agendamento',
  'Aguardando pagamento' = 'Aguardando pagamento',
  'Faltou à consulta' = 'Faltou à consulta',
  'Reagendado' = 'Reagendado',
  'Arquivado' = 'Arquivado',
  'Cancelado' = 'Cancelado',
}

export enum EIndicationTypeStatus {
  SCHEDULE = 'schedule',
  ATTENDANCE = 'attendance',
  ARCHIVE = 'archive',
}

export enum EScheduledIndicationStatus {
  'Todos' = 'Todos',
  'Aguardando agendamento' = 'Aguardando agendamento',
  'Agendado' = 'Agendado',
  'Aguardando novo agendamento' = 'Aguardando novo agendamento',
  'Aguardando pagamento' = 'Aguardando pagamento',
  'Faltou à consulta' = 'Faltou à consulta',
  'Reagendado' = 'Reagendado',
  'Cancelado' = 'Cancelado',
}

export enum EAttendedIndicationStatus {
  'Todos' = 'Todos',
  'Entregues' = 'Entregues',
  'Pendentes' = 'Pendentes',
}

export enum EIndicationDocumentStatus {
  RECEIVED = 'RECEIVED',
  PENDING = 'PENDING',
}

export enum EIndicationScheduleStatus {
  ACTIVE = 'ativo',
  RESCHEDULED = 'reagendado',
  CANCELLED = 'cancelado',
  MISSED_SCHEDULE = 'faltou à consulta',
}
